var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 154,
    viewBox: "0 0 156 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000016597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9105 7.63086H7.69922V11.8355H20.9105V7.63086Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M148.589 45.2854H135.002V40.7051H148.589V45.2854ZM135.378 44.9097H148.213V41.0808H135.378V44.9097Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.5416 2.32924C11.3472 2.36682 5.72228 2.46075 3.60306 2.48706H0.330302L0.503146 2.31421V6.51883L0.315272 6.33095C2.50964 6.33095 8.10451 6.36101 10.2237 6.39107L13.5265 6.4324L13.4364 6.51883L13.5265 2.31421L13.5416 2.32924ZM13.5416 2.32924L13.628 6.53385V6.62403H13.5378C11.8883 6.64658 8.57795 6.68415 6.93218 6.69543L0.326546 6.72173H0.138672V6.53385V2.32924V2.16016H0.307757H3.64064C5.74482 2.1827 11.3435 2.27664 13.519 2.31421L13.5416 2.32924Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.6197 102.586C33.4253 102.624 27.7966 102.717 25.6812 102.744H22.4084L22.5775 102.571V106.776L22.3896 106.588C24.584 106.588 30.1789 106.618 32.2981 106.648L35.6009 106.689L35.5107 106.776L35.6009 102.571L35.6197 102.586ZM35.6197 102.586L35.7061 106.791V106.881H35.6159C33.9664 106.903 30.6561 106.941 29.0103 106.956L22.4047 106.978H22.2168V106.787V102.582V102.413H22.3896H25.7225C27.8267 102.436 33.4253 102.533 35.6009 102.567L35.6197 102.586Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.2488 97.2852C26.0544 97.3227 20.4295 97.4167 18.314 97.443H15.0412L15.2103 97.2701V101.475L15.0225 101.287C17.2131 101.287 22.8079 101.317 24.9272 101.347L28.23 101.388L28.1435 101.475L28.23 97.2701L28.2488 97.2852ZM28.2488 97.2852L28.3389 101.49V101.58H28.245C26.5992 101.602 23.2889 101.64 21.6394 101.655L15.0375 101.678H14.8496V101.486V97.2814V97.1123H15.0225H18.3516C20.4595 97.1348 26.0582 97.2325 28.23 97.2664L28.2488 97.2852Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20.9105 102.586H7.69922V106.791H20.9105V102.586Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M155.77 2.33008H142.559V6.53469H155.77V2.33008Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M148.401 149.607H135.189V153.812H148.401V149.607Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M155.77 144.306C153.576 144.344 147.951 144.438 145.832 144.464H142.559L142.732 144.291V148.496L142.544 148.308C144.738 148.308 150.333 148.334 152.452 148.368L155.755 148.406L155.665 148.496L155.755 144.291L155.77 144.306ZM155.77 144.306L155.86 148.511V148.601H155.77C154.121 148.623 150.814 148.661 149.165 148.672L142.559 148.699H142.371V148.522L142.39 144.317V144.145H142.559H145.892C147.996 144.167 153.598 144.261 155.77 144.299V144.306Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.5416 149.607C11.3472 149.645 5.72228 149.739 3.60306 149.761L0.330302 149.78L0.503146 149.607V153.812L0.315272 153.624C2.50964 153.624 8.10451 153.65 10.2237 153.681L13.5265 153.722L13.4364 153.812L13.5265 149.607H13.5416ZM13.5416 149.607L13.628 153.812V153.902H13.5378C11.8883 153.925 8.57795 153.962 6.93218 153.974L0.326546 154H0.138672V153.812V149.607V149.435H0.307757H3.64064C5.74482 149.457 11.3435 149.551 13.519 149.589L13.5416 149.607Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M154.034 1.09375H65.0723V65.3616H154.034V1.09375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M155.124 66.4509H63.9824V0H155.124V66.4509ZM66.1618 64.2678H152.959V2.18309H66.1618V64.2678Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M115.801 36.9658C115.764 36.966 115.728 36.957 115.696 36.9395L110.984 34.2191C110.953 34.2005 110.926 34.1742 110.908 34.1426C110.89 34.111 110.88 34.0753 110.879 34.0387V28.5942C110.879 28.5575 110.889 28.5216 110.908 28.49C110.926 28.4584 110.952 28.4321 110.984 28.4138L115.696 25.6896C115.729 25.6728 115.765 25.6641 115.801 25.6641C115.838 25.6641 115.874 25.6728 115.906 25.6896L120.622 28.4138C120.653 28.4323 120.679 28.4587 120.697 28.4904C120.715 28.522 120.724 28.5578 120.723 28.5942V34.0387C120.724 34.075 120.714 34.1107 120.696 34.1423C120.679 34.1739 120.653 34.2003 120.622 34.2191L115.906 36.9245C115.876 36.9478 115.839 36.9621 115.801 36.9658ZM111.292 33.9185L115.801 36.5187L120.31 33.9185V28.7144L115.801 26.1105L111.292 28.7144V33.9185Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M115.8 26.0804C115.745 26.0795 115.693 26.0569 115.654 26.0175C115.615 25.9781 115.594 25.9252 115.594 25.87V22.6461C115.594 22.5913 115.616 22.5387 115.654 22.5C115.693 22.4612 115.746 22.4395 115.8 22.4395C115.854 22.4414 115.905 22.464 115.942 22.5026C115.979 22.5411 116 22.5926 116 22.6461V25.8775C115.999 25.9304 115.977 25.9809 115.94 26.0187C115.903 26.0564 115.853 26.0785 115.8 26.0804Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M124.759 25.3518C124.705 25.3518 124.652 25.33 124.613 25.2913C124.575 25.2525 124.553 25.2 124.553 25.1452V21.9137C124.552 21.8864 124.557 21.8593 124.567 21.834C124.578 21.8087 124.593 21.7858 124.612 21.7665C124.631 21.7472 124.654 21.732 124.68 21.7218C124.705 21.7116 124.732 21.7066 124.759 21.7071C124.814 21.7071 124.867 21.7288 124.906 21.7676C124.944 21.8064 124.966 21.8589 124.966 21.9137V25.1452C124.966 25.2 124.944 25.2525 124.906 25.2913C124.867 25.33 124.814 25.3518 124.759 25.3518Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M120.51 28.8004C120.472 28.8012 120.435 28.7914 120.402 28.7722C120.37 28.7529 120.343 28.725 120.326 28.6914C120.301 28.6428 120.296 28.5865 120.311 28.5341C120.327 28.4818 120.362 28.4372 120.409 28.4096L123.152 26.9066C123.175 26.8934 123.202 26.8851 123.229 26.8821C123.256 26.8791 123.284 26.8815 123.31 26.8892C123.336 26.8969 123.36 26.9097 123.382 26.9269C123.403 26.9441 123.42 26.9653 123.433 26.9893C123.447 27.0132 123.455 27.0395 123.458 27.0666C123.461 27.0938 123.459 27.1213 123.451 27.1475C123.443 27.1737 123.43 27.1981 123.413 27.2193C123.396 27.2405 123.375 27.2581 123.351 27.2711L120.608 28.7741C120.578 28.792 120.544 28.8011 120.51 28.8004Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M128.941 28.8004C128.907 28.8011 128.873 28.792 128.844 28.7741L126.101 27.2711C126.077 27.2581 126.055 27.2405 126.038 27.2193C126.021 27.1981 126.008 27.1737 126.001 27.1475C125.993 27.1213 125.99 27.0938 125.993 27.0666C125.996 27.0395 126.005 27.0132 126.018 26.9893C126.031 26.9653 126.049 26.9441 126.07 26.9269C126.091 26.9097 126.115 26.8969 126.142 26.8892C126.168 26.8815 126.195 26.8791 126.222 26.8821C126.25 26.8851 126.276 26.8934 126.3 26.9066L129.043 28.4096C129.091 28.4366 129.126 28.4811 129.141 28.5337C129.157 28.5864 129.151 28.643 129.125 28.6914C129.108 28.725 129.081 28.7529 129.049 28.7722C129.016 28.7914 128.979 28.8012 128.941 28.8004Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M119.615 33.6363C119.56 33.6353 119.507 33.6127 119.468 33.5734C119.43 33.534 119.408 33.4811 119.408 33.4259V29.2701C119.408 29.2153 119.43 29.1628 119.469 29.124C119.507 29.0852 119.56 29.0635 119.615 29.0635C119.67 29.0635 119.722 29.0852 119.761 29.124C119.8 29.1628 119.822 29.2153 119.822 29.2701V33.4259C119.822 33.4534 119.817 33.4806 119.807 33.5061C119.797 33.5317 119.782 33.5549 119.762 33.5745C119.743 33.5941 119.72 33.6096 119.695 33.6202C119.67 33.6309 119.642 33.6363 119.615 33.6363Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M112.137 29.2556C112.101 29.2557 112.065 29.2464 112.034 29.2286C112.002 29.2108 111.976 29.1852 111.957 29.1542C111.943 29.1306 111.934 29.1044 111.93 29.0772C111.926 29.0499 111.928 29.0222 111.935 28.9956C111.942 28.969 111.954 28.9441 111.971 28.9223C111.987 28.9005 112.008 28.8822 112.032 28.8686L115.624 26.7795C115.674 26.7521 115.733 26.7456 115.787 26.7614C115.842 26.7773 115.888 26.8142 115.915 26.864C115.943 26.9138 115.949 26.9725 115.934 27.0271C115.918 27.0817 115.881 27.1278 115.831 27.1552L112.243 29.2293C112.21 29.2468 112.174 29.2559 112.137 29.2556Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M88.9086 16.7771C88.8733 16.7759 88.8386 16.7669 88.8072 16.7508L84.0915 14.0266C84.0598 14.0083 84.0334 13.9821 84.015 13.9504C83.9965 13.9188 83.9867 13.8829 83.9863 13.8463V8.40171C83.987 8.36517 83.997 8.32941 84.0155 8.29784C84.0339 8.26627 84.0601 8.23994 84.0915 8.22135L88.8072 5.50094C88.8385 5.48242 88.8741 5.47266 88.9105 5.47266C88.9469 5.47266 88.9825 5.48242 89.0138 5.50094L93.7295 8.22135C93.7605 8.24012 93.7861 8.26659 93.8039 8.29819C93.8217 8.32979 93.831 8.36545 93.8309 8.40171V13.8463C93.8313 13.8826 93.8222 13.9184 93.8044 13.9501C93.7866 13.9817 93.7607 14.0081 93.7295 14.0266L89.0138 16.7508C88.981 16.767 88.9452 16.776 88.9086 16.7771ZM84.3997 13.726L88.9086 16.33L93.4176 13.726V8.52195L88.9086 5.92178L84.3997 8.52195V13.726Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M93.6253 8.61218C93.5879 8.61138 93.5512 8.60093 93.519 8.58184C93.4867 8.56275 93.4599 8.53567 93.4412 8.50321C93.4165 8.45455 93.4113 8.39828 93.4266 8.34591C93.442 8.29353 93.4768 8.249 93.5239 8.2214L96.2668 6.71841C96.3157 6.69156 96.3732 6.68518 96.4267 6.70068C96.4802 6.71618 96.5254 6.75229 96.5524 6.80108C96.5771 6.84974 96.5823 6.906 96.567 6.95838C96.5516 7.01076 96.5168 7.05529 96.4697 7.08289L93.7268 8.58588C93.6951 8.60156 93.6606 8.61052 93.6253 8.61218Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M85.2458 13.4441C85.2185 13.4446 85.1914 13.4396 85.1661 13.4294C85.1408 13.4192 85.1178 13.404 85.0985 13.3847C85.0792 13.3654 85.064 13.3425 85.0538 13.3171C85.0436 13.2918 85.0386 13.2647 85.0391 13.2375V9.0817C85.0386 9.05442 85.0436 9.02732 85.0538 9.00201C85.064 8.97671 85.0792 8.95372 85.0985 8.93443C85.1178 8.91514 85.1408 8.89993 85.1661 8.88973C85.1914 8.87952 85.2185 8.87453 85.2458 8.87504C85.3006 8.87504 85.3531 8.89681 85.3919 8.93557C85.4306 8.97432 85.4524 9.02689 85.4524 9.0817V13.2525C85.4486 13.3047 85.4252 13.3534 85.3868 13.389C85.3485 13.4246 85.2981 13.4443 85.2458 13.4441Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M92.7038 9.0671C92.6679 9.06641 92.6328 9.05603 92.6023 9.03704L89.0102 6.94789C88.9859 6.93466 88.9646 6.91662 88.9475 6.89485C88.9304 6.87309 88.918 6.84806 88.911 6.82132C88.9039 6.79458 88.9024 6.76668 88.9066 6.73933C88.9107 6.71199 88.9204 6.68578 88.935 6.66232C88.9625 6.61507 89.0076 6.58063 89.0604 6.56655C89.1132 6.55246 89.1695 6.55988 89.2168 6.58717L92.809 8.67632C92.8565 8.70453 92.891 8.75028 92.9051 8.80371C92.9191 8.85714 92.9116 8.91396 92.8841 8.96189C92.8661 8.99386 92.8399 9.02046 92.8082 9.03895C92.7765 9.05744 92.7405 9.06716 92.7038 9.0671Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M89.1121 15.7478C89.0696 15.7444 89.0292 15.728 88.9965 15.7008C88.9637 15.6735 88.9401 15.6368 88.929 15.5957C88.9179 15.5545 88.9198 15.511 88.9344 15.4709C88.949 15.4309 88.9757 15.3964 89.0107 15.3721L92.6028 13.2829C92.6261 13.2689 92.652 13.2597 92.679 13.2559C92.7059 13.2521 92.7333 13.2537 92.7596 13.2608C92.7859 13.2678 92.8105 13.28 92.832 13.2967C92.8535 13.3134 92.8714 13.3343 92.8846 13.3581C92.9121 13.406 92.9196 13.4628 92.9055 13.5162C92.8915 13.5697 92.857 13.6154 92.8095 13.6436L89.2173 15.7328C89.1842 15.7469 89.1479 15.7521 89.1121 15.7478Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M140.702 21.4588C140.665 21.458 140.628 21.4477 140.596 21.4287L135.881 18.7083C135.849 18.6898 135.824 18.6634 135.806 18.6317C135.788 18.6001 135.779 18.5643 135.779 18.5279V13.0833C135.779 13.047 135.788 13.0112 135.806 12.9796C135.824 12.9479 135.849 12.9215 135.881 12.903L140.596 10.1826C140.628 10.1641 140.663 10.1543 140.7 10.1543C140.736 10.1543 140.772 10.1641 140.803 10.1826L145.519 12.903C145.55 12.9213 145.577 12.9476 145.595 12.9792C145.614 13.0108 145.624 13.0467 145.624 13.0833V18.5129C145.624 18.5495 145.614 18.5854 145.595 18.617C145.577 18.6487 145.55 18.6749 145.519 18.6933L140.799 21.4287C140.77 21.447 140.736 21.4574 140.702 21.4588ZM136.193 18.4077L140.702 21.0116L145.211 18.4077V13.2036L140.702 10.6034L136.193 13.2036V18.4077Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M145.413 13.2902C145.371 13.2862 145.331 13.2692 145.299 13.2417C145.267 13.2142 145.244 13.1775 145.233 13.1365C145.223 13.0955 145.225 13.0522 145.24 13.0125C145.254 12.9728 145.281 12.9385 145.316 12.9145L148.059 11.4115C148.109 11.3851 148.167 11.3795 148.221 11.3961C148.275 11.4127 148.32 11.4499 148.346 11.4998C148.373 11.5496 148.378 11.6079 148.362 11.6618C148.345 11.7157 148.308 11.7608 148.258 11.7872L145.515 13.2902C145.481 13.2975 145.447 13.2975 145.413 13.2902Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M137.043 18.1371C136.988 18.1371 136.935 18.1153 136.896 18.0766C136.858 18.0378 136.836 17.9853 136.836 17.9305V13.7634C136.843 13.7129 136.868 13.6666 136.906 13.6331C136.944 13.5995 136.994 13.5811 137.044 13.5811C137.095 13.5811 137.145 13.5995 137.183 13.6331C137.221 13.6666 137.246 13.7129 137.253 13.7634V17.9192C137.254 17.9474 137.249 17.9756 137.239 18.002C137.229 18.0284 137.214 18.0525 137.194 18.0729C137.174 18.0932 137.151 18.1094 137.125 18.1204C137.099 18.1315 137.071 18.1371 137.043 18.1371Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M144.497 13.7452C144.46 13.746 144.424 13.7369 144.392 13.7189L140.8 11.6298C140.775 11.6159 140.753 11.5974 140.736 11.5752C140.718 11.553 140.705 11.5276 140.698 11.5003C140.69 11.4731 140.688 11.4447 140.691 11.4166C140.694 11.3885 140.703 11.3614 140.717 11.3367C140.731 11.312 140.749 11.2903 140.771 11.2728C140.794 11.2553 140.819 11.2423 140.846 11.2346C140.874 11.227 140.902 11.2247 140.93 11.2281C140.958 11.2314 140.985 11.2402 141.01 11.254L144.602 13.3432C144.649 13.372 144.683 13.4178 144.697 13.4709C144.711 13.5241 144.704 13.5806 144.677 13.6287C144.661 13.6628 144.635 13.6917 144.603 13.7122C144.572 13.7328 144.535 13.7442 144.497 13.7452Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M140.905 20.4291C140.862 20.4264 140.821 20.4105 140.788 20.3835C140.754 20.3566 140.73 20.3199 140.719 20.2786C140.707 20.2373 140.709 20.1935 140.723 20.1531C140.738 20.1128 140.764 20.0779 140.799 20.0534L144.392 17.9642C144.415 17.9504 144.441 17.9414 144.468 17.9376C144.495 17.9338 144.522 17.9353 144.549 17.9421C144.575 17.9489 144.6 17.9609 144.621 17.9772C144.643 17.9936 144.661 18.0141 144.675 18.0375C144.689 18.061 144.698 18.0869 144.702 18.1138C144.706 18.1408 144.704 18.1682 144.697 18.1945C144.691 18.2209 144.679 18.2456 144.662 18.2674C144.646 18.2891 144.625 18.3074 144.602 18.3212L141.01 20.3916C140.979 20.413 140.942 20.426 140.905 20.4291Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M87.9956 25.895L7.97461 36.1602L21.9755 145.303L101.997 135.038L87.9956 25.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M18.4378 145.755L21.9746 145.302L7.97368 36.1585L4.43682 36.6122L18.4378 145.755Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M87.9956 25.8931L7.97461 36.1582L9.37207 47.052L89.3931 36.7869L87.9956 25.8931Z",
    fill: "#FFB181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M7.97045 36.1576L4.43359 36.6113L5.83106 47.5052L9.36792 47.0514L7.97045 36.1576Z",
    fill: "#C25C1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M6.19221 47.4585L6.00586 47.4824L18.6093 145.732L18.7957 145.708L6.19221 47.4585Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M6.62189 47.4048L6.43555 47.4287L19.0395 145.682L19.2258 145.658L6.62189 47.4048Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M7.05158 47.3472L6.86523 47.3711L19.4687 145.62L19.655 145.597L7.05158 47.3472Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M7.5942 47.0957L7.4082 47.1201L20.2853 145.184L20.4713 145.16L7.5942 47.0957Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M8.01998 47.041L7.83398 47.0654L20.7116 145.133L20.8976 145.109L8.01998 47.041Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M8.33478 47.1812L8.14844 47.2051L20.7524 145.458L20.9387 145.434L8.33478 47.1812Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M8.76447 47.1275L8.57812 47.1514L21.1816 145.401L21.3679 145.377L8.76447 47.1275Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M9.19221 47.0728L9.00586 47.0967L21.6098 145.35L21.7962 145.326L9.19221 47.0728Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M23.5227 80.4248L52.4375 76.6279L52.3584 76.0253L23.4436 79.8222L23.5227 80.4248Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M24.0618 83.2602L53.0312 79.5439L52.9538 78.9402L23.9844 82.6564L24.0618 83.2602Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M23.237 76.8674L85.8457 68.8359L85.7683 68.2322L23.1595 76.2636L23.237 76.8674Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M22.4206 70.4807L85.0293 62.4492L84.9518 61.8455L22.3431 69.8769L22.4206 70.4807Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M22.0124 67.2834L84.6211 59.252L84.5436 58.6482L21.9349 66.6797L22.0124 67.2834Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M21.1901 60.8977L83.7988 52.8662L83.7214 52.2624L21.1126 60.2939L21.1901 60.8977Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M20.778 57.7014L83.3867 49.6699L83.3093 49.0662L20.7005 57.0976L20.778 57.7014Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M24.4661 86.4535L53.4355 82.7373L53.3581 82.1335L24.3886 85.8498L24.4661 86.4535Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M24.8743 89.6459L53.8438 85.9297L53.7663 85.3259L24.7969 89.0421L24.8743 89.6459Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M25.2864 92.8432L54.2559 89.127L54.1784 88.5232L25.209 92.2394L25.2864 92.8432Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M25.6946 96.0404L54.6641 92.3242L54.5866 91.7205L25.6172 95.4367L25.6946 96.0404Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M26.1067 99.2367L55.0762 95.5205L54.9987 94.9167L26.0293 98.633L26.1067 99.2367Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M26.5149 102.426L55.4844 98.71L55.4069 98.1062L26.4375 101.822L26.5149 102.426Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M26.927 105.622L55.8965 101.906L55.819 101.302L26.8496 105.019L26.927 105.622Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M27.3352 108.82L56.3047 105.104L56.2272 104.5L27.2578 108.216L27.3352 108.82Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M28.1556 115.205L57.125 111.489L57.0475 110.885L28.0781 114.602L28.1556 115.205Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M28.5657 118.403L57.5352 114.687L57.4577 114.083L28.4883 117.799L28.5657 118.403Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M57.2884 75.7455L86.2578 72.0293L86.1804 71.4255L57.2109 75.1417L57.2884 75.7455Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M57.6966 78.9418L86.666 75.2256L86.5886 74.6218L57.6191 78.338L57.6966 78.9418Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M58.1087 82.1381L87.0781 78.4219L87.0007 77.8181L58.0312 81.5343L58.1087 82.1381Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M58.5188 85.3354L87.4883 81.6191L87.4108 81.0154L58.4414 84.7316L58.5188 85.3354Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M58.9309 88.5287L87.9004 84.8125L87.8229 84.2087L58.8535 87.9249L58.9309 88.5287Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M59.7434 94.9184L88.7129 91.2021L88.6354 90.5984L59.666 94.3146L59.7434 94.9184Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M60.1556 98.1117L89.125 94.3955L89.0475 93.7917L60.0781 97.508L60.1556 98.1117Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M60.5638 101.308L89.5332 97.5918L89.4558 96.988L60.4863 100.704L60.5638 101.308Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M60.9759 104.501L89.9453 100.785L89.8679 100.181L60.8984 103.898L60.9759 104.501Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M61.3841 107.695L90.3535 103.979L90.2761 103.375L61.3066 107.091L61.3841 107.695Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M61.7962 110.891L90.7656 107.175L90.6882 106.571L61.7187 110.287L61.7962 110.891Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M62.2063 114.088L91.1758 110.372L91.0983 109.768L62.1289 113.485L62.2063 114.088Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    opacity: 0.1,
    d: "M18.449 39.5553C18.4966 39.9239 18.4338 40.2984 18.2684 40.6313C18.1031 40.9643 17.8427 41.2407 17.5203 41.4256C17.1978 41.6105 16.8277 41.6956 16.4569 41.67C16.086 41.6445 15.7311 41.5096 15.4369 41.2823C15.1428 41.055 14.9227 40.7455 14.8045 40.3931C14.6863 40.0407 14.6753 39.6611 14.773 39.3024C14.8706 38.9438 15.0724 38.6221 15.3528 38.3781C15.6333 38.1342 15.9799 37.9789 16.3486 37.932C16.8423 37.8692 17.3408 38.0048 17.7346 38.3092C18.1284 38.6135 18.3853 39.0617 18.449 39.5553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M17.7133 39.6336C17.7396 39.8536 17.7006 40.0765 17.601 40.2745C17.5014 40.4724 17.3457 40.6366 17.1533 40.7466C16.9609 40.8565 16.7404 40.9073 16.5193 40.8926C16.2982 40.8779 16.0863 40.7984 15.9102 40.664C15.734 40.5295 15.6014 40.3462 15.5289 40.1368C15.4564 39.9274 15.4472 39.7013 15.5024 39.4867C15.5577 39.2721 15.675 39.0786 15.8397 38.9303C16.0043 38.782 16.209 38.6855 16.4282 38.6529C16.5773 38.6307 16.7293 38.6387 16.8752 38.6763C17.0212 38.7139 17.1581 38.7803 17.2779 38.8718C17.3977 38.9632 17.498 39.0777 17.5727 39.2086C17.6475 39.3394 17.6953 39.484 17.7133 39.6336Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    opacity: 0.1,
    d: "M28.1658 38.2926C28.2134 38.6612 28.1506 39.0357 27.9852 39.3686C27.8199 39.7016 27.5595 39.978 27.2371 40.1629C26.9146 40.3478 26.5445 40.4328 26.1737 40.4073C25.8028 40.3818 25.4479 40.2469 25.1537 40.0196C24.8596 39.7923 24.6395 39.4828 24.5213 39.1304C24.4031 38.778 24.3921 38.3984 24.4897 38.0397C24.5874 37.6811 24.7892 37.3594 25.0696 37.1154C25.3501 36.8715 25.6967 36.7163 26.0654 36.6693C26.5591 36.6065 27.0576 36.7422 27.4514 37.0465C27.8452 37.3508 28.1021 37.799 28.1658 38.2926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M27.4298 38.3864C27.4567 38.6071 27.4177 38.8308 27.3178 39.0294C27.2179 39.228 27.0615 39.3926 26.8683 39.5025C26.675 39.6125 26.4536 39.6628 26.2318 39.6472C26.0101 39.6316 25.7978 39.5508 25.6219 39.415C25.4459 39.2791 25.3141 39.0942 25.2429 38.8836C25.1717 38.673 25.1644 38.446 25.2219 38.2313C25.2794 38.0165 25.3991 37.8235 25.566 37.6766C25.7329 37.5297 25.9395 37.4355 26.1598 37.4057C26.3077 37.3857 26.4581 37.3952 26.6023 37.4339C26.7465 37.4725 26.8816 37.5393 26.9998 37.6305C27.1179 37.7218 27.2168 37.8356 27.2906 37.9653C27.3644 38.0951 27.4117 38.2382 27.4298 38.3864Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    opacity: 0.1,
    d: "M37.8826 37.0484C37.9302 37.4171 37.8674 37.7916 37.702 38.1245C37.5367 38.4574 37.2763 38.7338 36.9539 38.9187C36.6314 39.1036 36.2613 39.1887 35.8905 39.1632C35.5196 39.1377 35.1647 39.0028 34.8705 38.7755C34.5764 38.5482 34.3563 38.2387 34.2381 37.8863C34.1199 37.5338 34.1089 37.1543 34.2065 36.7956C34.3042 36.4369 34.506 36.1153 34.7864 35.8713C35.0669 35.6274 35.4135 35.4721 35.7822 35.4252C36.2759 35.3624 36.7744 35.498 37.1682 35.8023C37.562 36.1067 37.8189 36.5548 37.8826 37.0484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M37.149 37.1425C37.1751 37.363 37.1354 37.5862 37.0351 37.7843C36.9347 37.9823 36.7781 38.1463 36.585 38.2556C36.3918 38.365 36.1706 38.4149 35.9492 38.3991C35.7277 38.3832 35.5159 38.3024 35.3403 38.1666C35.1646 38.0309 35.033 37.8463 34.9618 37.636C34.8907 37.4257 34.8832 37.1991 34.9403 36.9846C34.9975 36.77 35.1167 36.5772 35.283 36.4301C35.4493 36.2831 35.6554 36.1885 35.8753 36.1581C36.0238 36.1376 36.1749 36.1469 36.3197 36.1854C36.4646 36.224 36.6003 36.2911 36.7189 36.3828C36.8375 36.4745 36.9367 36.5889 37.0105 36.7193C37.0844 36.8498 37.1315 36.9937 37.149 37.1425Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    opacity: 0.1,
    d: "M47.6151 35.7974C47.6626 36.1661 47.5998 36.5406 47.4345 36.8735C47.2691 37.2065 47.0088 37.4829 46.6863 37.6678C46.3638 37.8527 45.9937 37.9377 45.6229 37.9122C45.252 37.8867 44.8971 37.7518 44.603 37.5245C44.3088 37.2972 44.0887 36.9877 43.9706 36.6353C43.8524 36.2829 43.8414 35.9033 43.939 35.5446C44.0366 35.1859 44.2384 34.8643 44.5189 34.6203C44.7993 34.3764 45.1459 34.2211 45.5146 34.1742C46.0083 34.1114 46.5068 34.247 46.9006 34.5514C47.2944 34.8557 47.5514 35.3038 47.6151 35.7974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M46.8971 35.8916C46.9231 36.112 46.8835 36.3353 46.7831 36.5333C46.6828 36.7313 46.5262 36.8953 46.333 37.0047C46.1398 37.114 45.9186 37.1639 45.6972 37.1481C45.4758 37.1323 45.264 37.0514 45.0883 36.9156C44.9127 36.7799 44.781 36.5953 44.7098 36.385C44.6387 36.1747 44.6312 35.9481 44.6884 35.7336C44.7455 35.5191 44.8647 35.3262 45.031 35.1792C45.1974 35.0321 45.4034 34.9375 45.6233 34.9071C45.7718 34.8866 45.9229 34.8959 46.0678 34.9345C46.2126 34.973 46.3483 35.0401 46.467 35.1318C46.5856 35.2235 46.6847 35.3379 46.7586 35.4684C46.8324 35.5988 46.8795 35.7427 46.8971 35.8916Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    opacity: 0.1,
    d: "M57.3846 34.5465C57.4322 34.9151 57.3693 35.2896 57.204 35.6226C57.0387 35.9555 56.7783 36.2319 56.4558 36.4168C56.1333 36.6017 55.7633 36.6868 55.3924 36.6613C55.0216 36.6357 54.6666 36.5008 54.3725 36.2735C54.0784 36.0462 53.8583 35.7368 53.7401 35.3843C53.6219 35.0319 53.6109 34.6523 53.7085 34.2936C53.8061 33.935 54.0079 33.6133 54.2884 33.3694C54.5689 33.1254 54.9154 32.9702 55.2842 32.9232C55.7779 32.8604 56.2763 32.9961 56.6701 33.3004C57.0639 33.6047 57.3209 34.0529 57.3846 34.5465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M56.633 34.6398C56.6598 34.8603 56.6208 35.0838 56.521 35.2823C56.4211 35.4807 56.2649 35.6452 56.0719 35.7552C55.8788 35.8651 55.6576 35.9156 55.436 35.9002C55.2144 35.8849 55.0023 35.8044 54.8263 35.6689C54.6503 35.5333 54.5182 35.3489 54.4467 35.1385C54.3752 34.9282 54.3674 34.7015 54.4244 34.4868C54.4813 34.272 54.6004 34.0789 54.7667 33.9317C54.933 33.7844 55.1392 33.6896 55.3592 33.6591C55.5074 33.6386 55.6582 33.6477 55.8029 33.6861C55.9475 33.7244 56.0831 33.7912 56.2016 33.8825C56.3202 33.9738 56.4194 34.0878 56.4935 34.2178C56.5675 34.3478 56.6149 34.4913 56.633 34.6398Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    opacity: 0.1,
    d: "M67.078 33.3023C67.1255 33.671 67.0627 34.0455 66.8974 34.3784C66.732 34.7113 66.4716 34.9877 66.1492 35.1726C65.8267 35.3575 65.4566 35.4426 65.0858 35.4171C64.7149 35.3916 64.36 35.2567 64.0659 35.0294C63.7717 34.8021 63.5516 34.4926 63.4334 34.1402C63.3152 33.7878 63.3043 33.4082 63.4019 33.0495C63.4995 32.6908 63.7013 32.3692 63.9818 32.1252C64.2622 31.8813 64.6088 31.726 64.9775 31.6791C65.4712 31.6163 65.9697 31.7519 66.3635 32.0562C66.7573 32.3606 67.0143 32.8087 67.078 33.3023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M66.3444 33.3964C66.3704 33.6169 66.3307 33.8401 66.2304 34.0382C66.13 34.2362 65.9735 34.4002 65.7803 34.5095C65.5871 34.6189 65.3659 34.6688 65.1445 34.653C64.9231 34.6371 64.7112 34.5563 64.5356 34.4205C64.3599 34.2848 64.2283 34.1002 64.1571 33.8899C64.086 33.6796 64.0785 33.453 64.1356 33.2385C64.1928 33.024 64.312 32.8311 64.4783 32.684C64.6446 32.537 64.8507 32.4424 65.0706 32.412C65.2191 32.3915 65.3702 32.4008 65.515 32.4393C65.6599 32.4779 65.7956 32.545 65.9142 32.6367C66.0328 32.7284 66.132 32.8428 66.2058 32.9732C66.2797 33.1037 66.3268 33.2476 66.3444 33.3964Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    opacity: 0.1,
    d: "M76.8065 32.0396C76.8541 32.4083 76.7912 32.7828 76.6259 33.1157C76.4605 33.4486 76.2002 33.7251 75.8777 33.9099C75.5552 34.0948 75.1851 34.1799 74.8143 34.1544C74.4434 34.1289 74.0885 33.994 73.7944 33.7667C73.5002 33.5394 73.2802 33.2299 73.162 32.8775C73.0438 32.5251 73.0328 32.1455 73.1304 31.7868C73.228 31.4281 73.4298 31.1065 73.7103 30.8625C73.9908 30.6186 74.3373 30.4633 74.706 30.4164C75.1998 30.3536 75.6982 30.4892 76.092 30.7936C76.4858 31.0979 76.7428 31.546 76.8065 32.0396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M76.0689 32.1489C76.0951 32.3695 76.0554 32.5929 75.955 32.7911C75.8546 32.9893 75.6978 33.1534 75.5044 33.2627C75.311 33.3721 75.0896 33.4219 74.868 33.4058C74.6464 33.3898 74.4345 33.3086 74.2589 33.1725C74.0833 33.0363 73.9518 32.8514 73.881 32.6408C73.8102 32.4302 73.8032 32.2034 73.8609 31.9888C73.9186 31.7743 74.0384 31.5815 74.2053 31.4349C74.3722 31.2882 74.5787 31.1941 74.7989 31.1644C74.9471 31.1444 75.0978 31.1541 75.2422 31.193C75.3867 31.2318 75.5219 31.299 75.6401 31.3906C75.7583 31.4822 75.8571 31.5965 75.9307 31.7266C76.0043 31.8568 76.0513 32.0003 76.0689 32.1489Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    opacity: 0.1,
    d: "M86.5643 30.8043C86.6119 31.1729 86.549 31.5474 86.3837 31.8804C86.2184 32.2133 85.958 32.4897 85.6355 32.6746C85.313 32.8595 84.9429 32.9446 84.5721 32.9191C84.2013 32.8936 83.8463 32.7586 83.5522 32.5313C83.258 32.304 83.038 31.9946 82.9198 31.6421C82.8016 31.2897 82.7906 30.9101 82.8882 30.5515C82.9858 30.1928 83.1876 29.8711 83.4681 29.6272C83.7486 29.3832 84.0951 29.228 84.4639 29.181C84.9576 29.1182 85.456 29.2539 85.8498 29.5582C86.2436 29.8625 86.5006 30.3107 86.5643 30.8043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M85.8287 30.9125C85.8548 31.1332 85.8152 31.3566 85.7148 31.5548C85.6143 31.753 85.4576 31.917 85.2642 32.0264C85.0708 32.1358 84.8494 32.1856 84.6278 32.1695C84.4062 32.1534 84.1943 32.0723 84.0187 31.9361C83.8431 31.8 83.7116 31.615 83.6408 31.4045C83.57 31.1939 83.563 30.967 83.6207 30.7525C83.6784 30.5379 83.7982 30.3452 83.9651 30.1985C84.132 30.0519 84.3385 29.9578 84.5587 29.9281C84.7069 29.9081 84.8576 29.9178 85.002 29.9566C85.1464 29.9955 85.2817 30.0627 85.3999 30.1543C85.5181 30.2459 85.6169 30.3601 85.6905 30.4903C85.7641 30.6205 85.8111 30.764 85.8287 30.9125Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M16.9942 35.7258C17.1144 36.6539 17.4 39.6937 17.4 39.6937C17.5353 40.7457 15.897 40.9524 15.773 39.9041C15.649 38.8557 15.3973 36.992 15.1793 35.2861C14.8787 32.9565 13.759 32.2463 12.7482 32.3779C11.4895 32.5394 10.9371 34.1514 11.14 35.7596L9.50555 35.97C9.03962 32.344 10.5915 30.7095 12.3763 30.4954C15.0892 30.1346 16.4907 31.7955 16.9942 35.7258Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M26.7226 34.4789C26.8428 35.407 27.1284 38.4467 27.1284 38.4467C27.2636 39.4988 25.6254 39.7055 25.5014 38.6572C25.3774 37.6088 25.1256 35.7451 24.9077 34.0355C24.6071 31.7096 23.4874 30.9994 22.4766 31.1309C21.2179 31.2925 20.6655 32.9045 20.8684 34.5127L19.2339 34.7231C18.768 31.0971 20.3236 29.4626 22.1046 29.2447C24.8175 28.8877 26.2191 30.5373 26.7226 34.4789Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M36.4511 33.2269C36.5713 34.1587 36.8569 37.1985 36.8569 37.1985C36.9921 38.2506 35.3539 38.4535 35.2299 37.409C35.1059 36.3644 34.8542 34.4969 34.6362 32.7873C34.3394 30.4614 33.2159 29.7512 32.2051 29.8827C30.9464 30.0443 30.394 31.6563 30.5969 33.2645L28.9624 33.4749C28.4965 29.8489 30.0521 28.2144 31.8331 27.9965C34.5498 27.6395 35.9664 29.2966 36.4511 33.2269Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M46.1796 31.9802C46.2998 32.9121 46.5854 35.9519 46.5854 35.9519C46.7207 37.004 45.0824 37.2069 44.9584 36.1585C44.8344 35.1102 44.5827 33.2503 44.3647 31.5406C44.0679 29.2147 42.9444 28.5046 41.9336 28.6323C40.6749 28.7939 40.1225 30.4059 40.3292 32.0141L38.6909 32.2245C38.225 28.5948 39.7806 26.964 41.5617 26.7461C44.2783 26.4041 45.6761 28.0499 46.1796 31.9802Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M55.9099 30.7325C56.0264 31.6644 56.312 34.7042 56.312 34.7042C56.4472 35.7563 54.809 35.9592 54.685 34.9108C54.561 33.8625 54.3092 32.0025 54.0913 30.2929C53.7945 27.967 52.671 27.2569 51.6602 27.3846C50.4015 27.5462 49.8491 29.1581 50.0558 30.7663L48.4175 30.973C47.9516 27.347 49.5072 25.7125 51.2882 25.4984C54.0011 25.1414 55.4027 26.8022 55.9099 30.7325Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M65.6501 29.4846C65.7666 30.4164 66.0522 33.4562 66.0522 33.4562C66.1875 34.5045 64.5492 34.7112 64.4252 33.6629C64.3012 32.6145 64.0495 30.7508 63.8315 29.0449C63.5347 26.7191 62.4112 26.0089 61.4042 26.1366C60.1417 26.2982 59.5893 27.9102 59.796 29.5184L58.1577 29.7288C57.6918 26.1028 59.2474 24.4683 61.0285 24.2542C63.7338 23.8934 65.1316 25.5542 65.6501 29.4846Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M75.3669 28.2375C75.4834 29.1656 75.769 32.2054 75.769 32.2054C75.9043 33.2575 74.266 33.4641 74.142 32.4158C74.018 31.3675 73.7663 29.5038 73.5483 27.7979C73.2515 25.4682 72.128 24.7618 71.121 24.8896C69.8622 25.0511 69.3061 26.6631 69.5128 28.2713L67.8745 28.4817C67.4086 24.8558 68.9642 23.2213 70.7453 23.0071C73.4619 22.6464 74.8634 24.3072 75.3669 28.2375Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M85.0955 26.9904C85.2157 27.9185 85.4975 30.9583 85.4975 30.9583C85.6328 32.0104 83.9945 32.2171 83.8705 31.1687C83.7465 30.1204 83.4948 28.2567 83.2768 26.5508C82.98 24.2212 81.8565 23.511 80.8495 23.6425C79.5908 23.8041 79.0347 25.416 79.2413 27.0242L77.6031 27.2347C77.1371 23.6087 78.6927 21.9742 80.4738 21.76C83.1904 21.3993 84.592 23.0601 85.0955 26.9904Z",
    fill: "#A6A6A6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M120.135 22.134V115.319H69.3039V115.492C69.3048 118.927 67.9616 122.226 65.5615 124.684C63.1615 127.142 59.895 128.563 56.4608 128.643H56.0062C55.5593 128.646 55.1126 128.622 54.6685 128.572L52.2186 128.068C51.6109 127.874 51.0182 127.635 50.4451 127.354C50.1588 127.227 49.8803 127.083 49.6109 126.922C49.4645 126.847 49.325 126.759 49.1939 126.659C48.8114 126.436 48.446 126.185 48.1004 125.908C48.0394 125.866 47.9816 125.819 47.9276 125.769C47.6609 125.58 47.4097 125.37 47.1761 125.141C47.0559 125.036 46.9356 124.916 46.8004 124.796C45.2855 123.304 44.1682 121.457 43.5501 119.422C43.5377 119.38 43.5201 119.34 43.4975 119.302C43.4111 118.99 43.3247 118.66 43.2571 118.329C43.1507 117.912 43.0803 117.488 43.0466 117.059C43.0128 116.867 43.0128 116.683 42.994 116.488C42.9867 116.424 42.9867 116.36 42.994 116.296C42.994 116.052 42.9414 115.827 42.9414 115.582V22.2693C42.9414 18.5832 40.3676 9.0918 28.9824 9.0918H107.081C108.795 9.09032 110.492 9.42657 112.076 10.0813C113.66 10.7361 115.099 11.6966 116.311 12.9078C117.523 14.119 118.485 15.5573 119.141 17.1404C119.797 18.7234 120.135 20.4203 120.135 22.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M120.134 22.1344C120.16 22.1908 120.202 115.346 120.22 115.406C120.239 115.466 69.3405 115.429 69.3217 115.455L69.457 115.32C69.4581 116.731 69.2531 118.135 68.8483 119.487C68.2052 121.512 67.09 123.355 65.5946 124.864C64.0991 126.373 62.2664 127.505 60.2474 128.167C58.4412 128.732 56.5392 128.925 54.6563 128.734L52.1877 128.23C51.4928 128.016 50.8187 127.739 50.1737 127.404C48.07 126.372 46.2803 124.797 44.9894 122.842C43.6986 120.886 42.9536 118.622 42.8316 116.282C42.7451 115.395 42.7865 113.806 42.779 112.9C42.779 110.645 42.779 104.401 42.779 102.056C42.7977 78.3049 42.8316 46.3138 42.8503 22.5365C42.8503 17.7833 40.2502 12.9399 35.9554 10.7418C33.7932 9.68829 31.4127 9.16043 29.0078 9.20123V9.00584C47.9567 9.05093 89.0334 9.00584 107.539 9.09978C114.464 9.26886 120.168 15.2057 120.123 22.1344H120.134ZM120.134 22.1344C120.164 15.232 114.475 9.28389 107.547 9.13735C89.2251 9.0885 47.8027 9.19747 29.0153 9.18996V9.00584C31.4518 8.95851 33.8649 9.48902 36.0568 10.5539C40.423 12.7783 43.057 17.6931 43.0871 22.5252C43.1134 46.3138 43.1397 78.2824 43.1585 102.045C43.1585 104.393 43.1585 110.612 43.1585 112.889C43.181 113.775 43.1059 115.387 43.2073 116.27C43.2417 116.901 43.3208 117.529 43.444 118.149C43.8401 120.063 44.664 121.863 45.8542 123.414C47.0443 124.964 48.5698 126.226 50.3164 127.103C50.9367 127.428 51.5842 127.699 52.2515 127.911L54.7014 128.418C56.5357 128.621 58.392 128.431 60.1476 127.862C61.9032 127.294 63.5182 126.359 64.8856 125.12C66.253 123.881 67.3418 122.365 68.08 120.674C68.8182 118.983 69.1889 117.154 69.1677 115.308V115.173H69.3029L120.115 115.222C119.987 115.786 120.115 21.9917 120.115 22.1232L120.134 22.1344Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M84.2538 16.9717L111.529 16.9717V16.2239L84.2538 16.2239V16.9717Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M52.578 36.7363H79.8535V35.9886H52.578V36.7363Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M52.578 40.6924H79.8535V39.9446H52.578V40.6924Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M52.578 44.6455H79.8535V43.8978H52.578V44.6455Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M52.578 48.5986H79.8535V47.8509H52.578V48.5986Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M52.578 52.5508H79.8535V51.803H52.578V52.5508Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M52.578 56.5039H79.8535V55.7562H52.578V56.5039Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M52.578 60.4531H79.8535V59.7054H52.578V60.4531Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M52.578 64.4062H79.8535V63.6585H52.578V64.4062Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M52.578 68.3594H79.8535V67.6116H52.578V68.3594Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M52.578 72.3154H79.8535V71.5677H52.578V72.3154Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M52.578 80.2217H79.8535V79.4739H52.578V80.2217Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M52.578 84.1738H79.8535V83.4261H52.578V84.1738Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M52.578 88.127H79.8535V87.3792H52.578V88.127Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M52.578 92.0801H79.8535V91.3323H52.578V92.0801Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M52.578 99.9854H79.8535V99.2376H52.578V99.9854Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M52.578 103.938H79.8535V103.191H52.578V103.938Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M52.578 107.895H79.8535V107.147H52.578V107.895Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M84.2538 20.9248L111.529 20.9248V20.1771L84.2538 20.1771V20.9248Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M84.2538 24.8779L111.529 24.8779V24.1302L84.2538 24.1302V24.8779Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M84.2538 28.8301L111.529 28.8301V28.0823L84.2538 28.0823V28.8301Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M84.2538 32.7832H111.529V32.0355H84.2538V32.7832Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M84.2538 36.7363H111.529V35.9886H84.2538V36.7363Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M84.2538 40.6924H111.529V39.9446H84.2538V40.6924Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M84.2538 44.6455H111.529V43.8978H84.2538V44.6455Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M84.2538 48.5986H111.529V47.8509H84.2538V48.5986Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M84.2538 52.5508H111.529V51.803H84.2538V52.5508Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M84.2538 60.4531H111.529V59.7054H84.2538V60.4531Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M84.2538 64.4062H111.529V63.6585H84.2538V64.4062Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M84.2538 68.3594H111.529V67.6116H84.2538V68.3594Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M84.2538 72.3154H111.529V71.5677H84.2538V72.3154Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M84.2538 76.2686H111.529V75.5208H84.2538V76.2686Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M84.2538 80.2217H111.529V79.4739H84.2538V80.2217Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M84.2538 84.1738H111.529V83.4261H84.2538V84.1738Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M84.2538 88.127H111.529V87.3792H84.2538V88.127Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M52.5781 16.9381L66.2177 16.9043C70.7643 16.9043 75.3071 16.9043 79.8536 16.9381C75.3071 16.9682 70.7643 16.9607 66.2177 16.9719L52.5781 16.9381Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M52.5781 17.9557L66.2177 17.9219C70.7643 17.9219 75.3071 17.9219 79.8536 17.9557C75.3071 17.9858 70.7643 17.9782 66.2177 17.9895L52.5781 17.9557Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M52.5781 18.9744L66.2177 18.9443C70.7643 18.9443 75.3071 18.9443 79.8536 18.9744C75.3071 19.0045 70.7643 18.9969 66.2177 19.0082L52.5781 18.9744Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M52.5781 19.993L66.2177 19.9629C70.7643 19.9629 75.3071 19.9629 79.8536 19.993C75.3071 20.023 70.7643 20.0155 66.2177 20.0268L52.5781 19.993Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M52.5781 21.0153L66.2177 20.9814C70.7643 20.9814 75.3071 20.9814 79.8536 21.0153C75.3071 21.0416 70.7643 21.0153 66.2177 21.0453L52.5781 21.0153Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M52.5781 22.0328L66.2177 21.999C70.7643 21.999 75.3071 21.999 79.8536 22.0328C75.3071 22.0591 70.7643 22.0328 66.2177 22.0667L52.5781 22.0328Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M52.5781 23.0514L66.2177 23.0176C70.7643 23.0176 75.3071 23.0176 79.8536 23.0514C75.3071 23.0777 70.7643 23.0739 66.2177 23.0852L52.5781 23.0514Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M52.5781 24.07L66.2177 24.0361C70.7643 24.0361 75.3071 24.0361 79.8536 24.07C75.3071 24.1 70.7643 24.0925 66.2177 24.1038L52.5781 24.07Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M52.5781 25.0875L66.2177 25.0537C70.7643 25.0537 75.3071 25.0537 79.8536 25.0875C75.3071 25.1176 70.7643 25.1101 66.2177 25.1213L52.5781 25.0875Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M52.5781 26.1061L66.2177 26.0723C70.7643 26.0723 75.3071 26.0723 79.8536 26.1061C75.3071 26.1361 70.7643 26.1286 66.2177 26.1399L52.5781 26.1061Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M52.5781 27.1246L66.2177 27.0908C70.7643 27.0908 75.3071 27.0908 79.8536 27.1246C75.3071 27.1547 70.7643 27.1472 66.2177 27.1585L52.5781 27.1246Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M52.5781 28.1424L66.2177 28.1123C70.7643 28.1123 75.3071 28.1123 79.8536 28.1424C75.3071 28.1724 70.7643 28.1649 66.2177 28.1762L52.5781 28.1424Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M52.5781 29.1647L66.2177 29.1309C70.7643 29.1309 75.3071 29.1309 79.8536 29.1647C75.3071 29.191 70.7643 29.1835 66.2177 29.1947L52.5781 29.1647Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M52.5781 30.1832L66.2177 30.1494C70.7643 30.1494 75.3071 30.1494 79.8536 30.1832C75.3071 30.2095 70.7643 30.1832 66.2177 30.2133L52.5781 30.1832Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M52.5781 31.2008L66.2177 31.167C70.7643 31.167 75.3071 31.167 79.8536 31.2008C75.3071 31.2271 70.7643 31.2008 66.2177 31.2346L52.5781 31.2008Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M57.5315 24.0693H55.4648V32.3884H57.5315V24.0693Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M61.3674 20.5488H59.3008V32.3849H61.3674V20.5488Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M65.2033 23.085H63.1367V32.3885H65.2033V23.085Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M69.0393 19.9932H66.9727V32.3853H69.0393V19.9932Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M72.8811 21.6572H70.8145V32.3886H72.8811V21.6572Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M76.717 27.7363H74.6504V32.3881H76.717V27.7363Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M53.3192 16.2236L53.3755 20.2629L53.4169 24.306C53.4432 27.0001 53.4507 29.6942 53.4544 32.3883L53.3192 32.2643H59.9549H66.5868L73.2225 32.3019L79.8544 32.377L73.2225 32.4484L66.5868 32.4897H59.9549H53.1914V32.3657C53.1914 29.6716 53.1914 26.9775 53.2327 24.2834L53.2703 20.2404L53.3192 16.2236Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M57.5315 33.2412H55.4648V33.4141H57.5315V33.2412Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M61.3674 33.2412H59.3008V33.4141H61.3674V33.2412Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M65.2033 33.2412H63.1367V33.4141H65.2033V33.2412Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M69.0393 33.2412H66.9727V33.4141H69.0393V33.2412Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M72.8811 33.2412H70.8145V33.4141H72.8811V33.2412Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M76.717 33.2412H74.6504V33.4141H76.717V33.2412Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M98.2587 97.5127C98.2585 98.8058 97.8779 100.07 97.1644 101.149C96.4508 102.227 95.4358 103.072 94.2457 103.577L91.6719 97.5127H98.2587Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M90.8259 97.0625L93.3997 103.123C93.1968 103.206 92.9939 103.281 92.7948 103.345C91.5202 103.736 90.1578 103.736 88.8832 103.345C87.8652 103.026 86.9396 102.464 86.1858 101.709C85.432 100.954 84.8723 100.027 84.5546 99.0088C84.1589 97.7363 84.1589 96.3736 84.5546 95.1011C84.8713 94.0828 85.4308 93.1567 86.1848 92.4027C86.9389 91.6486 87.865 91.0892 88.8832 90.7725C90.157 90.3766 91.521 90.3766 92.7948 90.7725C93.8134 91.0892 94.74 91.6486 95.4946 92.4026C96.2493 93.1566 96.8095 94.0827 97.1271 95.1011C97.3221 95.7341 97.4222 96.3926 97.424 97.055L90.8259 97.0625Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M90.8256 97.0623L93.3994 103.123C93.1965 103.206 92.9936 103.281 92.7945 103.345C91.4697 103.757 90.0485 103.741 88.7337 103.298C87.4188 102.855 86.2774 102.008 85.4723 100.878C84.6672 99.7477 84.2395 98.3923 84.2502 97.0049C84.2609 95.6174 84.7094 94.2688 85.5318 93.1513C86.3543 92.0338 87.5085 91.2046 88.8301 90.7819C90.1516 90.3592 91.5729 90.3646 92.8911 90.7973C94.2094 91.23 95.3574 92.068 96.1713 93.1916C96.9852 94.3153 97.4235 95.6673 97.4237 97.0548L90.8256 97.0623Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M90.8257 97.0622L86.5422 102.052C85.7063 101.333 85.0645 100.415 84.6759 99.3832C84.2874 98.3512 84.1644 97.2381 84.3183 96.1461C84.4723 95.0542 84.8982 94.0185 85.557 93.1342C86.2158 92.2498 87.0863 91.5453 88.0884 91.0852C89.0906 90.6252 90.1924 90.4244 91.2924 90.5014C92.3924 90.5784 93.4555 90.9306 94.3839 91.5257C95.3122 92.1208 96.0761 92.9397 96.6054 93.9071C97.1346 94.8746 97.4122 95.9595 97.4126 97.0622H90.8257Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M101.663 105.783H96.6917L90.5332 99.6283L90.6234 99.5381L96.7443 105.659H101.663V105.783Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M90.9238 99.2344H90.2324V99.9258H90.9238V99.2344Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M101.663 101.019H96.0607L93.4004 98.3626L93.4906 98.2725L96.1133 100.895H101.663V101.019Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M93.791 97.9717H93.0996V98.6631H93.791V97.9717Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M101.663 96.3066H93.1895V96.4344H101.663V96.3066Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M93.4414 96.0254H92.75V96.7168H93.4414V96.0254Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M109.745 95.6758H103.59V96.2469H109.745V95.6758Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M111.578 96.8701H103.59V97.4412H111.578V96.8701Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M107.858 98.0654H103.59V98.6366H107.858V98.0654Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M102.357 95.6758H100.967V97.0661H102.357V95.6758Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M110.492 100.301H103.59V100.872H110.492V100.301Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M109.346 101.496H103.59V102.067H109.346V101.496Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M111.578 102.694H103.59V103.265H111.578V102.694Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M102.357 100.301H100.967V101.691H102.357V100.301Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M110.492 104.927H103.59V105.498H110.492V104.927Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M109.346 106.125H103.59V106.696H109.346V106.125Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M111.578 107.32H103.59V107.891H111.578V107.32Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M102.357 104.927H100.967V106.317H102.357V104.927Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M29.9549 9.0957C33.4452 9.10068 36.7908 10.4909 39.2567 12.9611C41.7226 15.4312 43.1071 18.7791 43.1061 22.2694V27.9432H16.7813V22.2694C16.7808 20.5393 17.1212 18.826 17.783 17.2275C18.4449 15.6289 19.4152 14.1765 20.6386 12.9531C21.862 11.7297 23.3145 10.7594 24.913 10.0975C26.5115 9.43562 28.2248 9.09521 29.9549 9.0957Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M139.321 115.32V115.493C139.322 118.928 137.978 122.228 135.578 124.685C133.178 127.143 129.912 128.564 126.478 128.644H56.4609C59.8952 128.564 63.1616 127.143 65.5617 124.685C67.9617 122.228 69.3049 118.928 69.304 115.493V115.32H139.321Z",
    fill: "#FD6202"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M151.489 17.4879C151.489 18.924 151.09 20.3319 150.336 21.5545C149.583 22.7771 148.505 23.7664 147.222 24.4121C145.939 25.0578 144.503 25.3344 143.072 25.2111C141.641 25.0879 140.273 24.5696 139.119 23.7141L135.32 24.6835L136.902 21.144C136.346 20.1049 136.035 18.9527 135.991 17.775C135.947 16.5974 136.172 15.4252 136.65 14.3477C137.127 13.2702 137.843 12.3157 138.745 11.5568C139.647 10.7978 140.709 10.2545 141.852 9.96794C142.996 9.68142 144.189 9.65931 145.342 9.9033C146.495 10.1473 147.577 10.6509 148.506 11.376C149.435 12.101 150.187 13.0283 150.703 14.0874C151.22 15.1465 151.489 16.3095 151.489 17.4879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M151.489 17.4877C151.56 21.9553 147.506 25.6902 143.061 25.2995C141.609 25.1897 140.217 24.677 139.04 23.819L139.153 23.8416L135.362 24.8411L135.031 24.9275L135.17 24.6156L136.737 21.0723V21.2301C135.885 19.6298 135.61 17.785 135.958 16.0058C136.307 14.2265 137.257 12.6216 138.65 11.4607C143.741 7.25985 151.481 10.8971 151.481 17.4952L151.489 17.4877ZM151.489 17.4877C151.512 12.5353 146.664 8.75908 141.877 10.0742C137.173 11.239 134.738 16.8113 137.06 21.061L137.105 21.1399L137.068 21.2189L135.471 24.7471L135.279 24.5217L139.086 23.5823H139.149L139.198 23.6199C144.233 27.4337 151.459 23.804 151.489 17.5027V17.4877Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M142.482 22.1014L139.006 18.5844L140.174 17.4309L142.203 19.4862L146.419 12.873L147.802 13.7561L142.482 22.1014Z",
    fill: "#FD6202"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCertificate);
export default __webpack_public_path__ + "static/media/emptyCertificate.237051c91ea33112431f0b5b7e3c3e94.svg";
export { ForwardRef as ReactComponent };